import React, { useEffect } from "react";
import styled, { keyframes } from "styled-components";
import theme from "../../styles/theme";

const slideIn = keyframes`
  from {
    transform: translateY(-8px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
`;

// Anchored bottom-centre: at teleprompter width a top-right toast sat on top of
// the navbar controls, and it needs a z-index above the sticky nav or it is
// hidden behind it entirely.
const ToastContainer = styled.div`
  position: fixed;
  bottom: ${theme.space.lg};
  left: 50%;
  transform: translateX(-50%);
  max-width: calc(100vw - 2rem);
  padding: ${theme.space.sm} ${theme.space.lg};
  border-radius: ${theme.radius.sm};
  color: #ffffff;
  font-size: ${theme.font.sm};
  box-shadow: ${theme.shadow.panel};
  z-index: ${theme.z.toast};
  animation: ${slideIn} 0.2s ease-out;
  background-color: ${({ $type }) =>
    $type === "error" ? "#dc2626" : $type === "success" ? "#059669" : "#2563eb"};

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

const Toast = ({ message, type, onDismiss }) => {
  useEffect(() => {
    const timer = setTimeout(onDismiss, 3000);
    return () => clearTimeout(timer);
  }, [onDismiss]);

  return (
    <ToastContainer
      $type={type}
      role={type === "error" ? "alert" : "status"}
      aria-live={type === "error" ? "assertive" : "polite"}
    >
      {message}
    </ToastContainer>
  );
};

export default Toast;
